'use client';

import replaceContact from '@/src/utils/replaceContact';
import { useTranslations } from 'next-intl';
import { useEffect } from 'react';
import { BsExclamationOctagonFill } from 'react-icons/bs';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const t = useTranslations('errors');

  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <>
      <h1 className='mb-8 block border-b-4 text-[#B2B2B2] border-brand pb-2 text-xl uppercase md:text-3xl'>
        {t('title')}
      </h1>
      <div className='mx-auto flex w-full max-w-[600px] flex-col items-center gap-8 rounded bg-brand-alt/80 p-8 font-semibold text-white sm:flex-row'>
        <div className='text-3xl'>
          <BsExclamationOctagonFill />
        </div>
        <div className='flex flex-col gap-4'>
          <p>{t('desc')}</p>
          <button
            className='rounded-sm border-2 border-black bg-brand px-4 py-2 text-center font-semibold uppercase text-dark transition-all hover:border-brand hover:bg-black hover:text-white'
            onClick={() => reset()}
          >
            {t('tryAgain')}
          </button>
          <p
            dangerouslySetInnerHTML={{
              __html: replaceContact(t('ifIssuePersists')),
            }}
          ></p>
        </div>
      </div>
    </>
  );
}
